import styled from "styled-components";

export const Container = styled.div`
  height: ${props => props.height};
  width: ${props => props.width};
`;
